import champollion from "../assets/champollion.jpg"
import clubPresseGrenoble from "../assets/presse-grenoble.jpg"

export const educationContent = [
    {
        name: 'Lycée Champollion',
        type: 'Preparatory Class',
        image: champollion,
        text1: `I was fortunate to spend my two years of preparatory classes at the largest high school 
        in my department. Thanks to the new MPI track, I could already focus on subjects that aligned closely 
        with my interests while still receiving a well-rounded education in math and physics, just like in other 
        preparatory programs.`,
        text2: ``
    },
    {
        name: 'More to come...',
        type: '',
        image: '',
        text1: ``,
        text2: ``
    }
]